import type { ComponentProps } from "react";
import { cn } from "../cn";

/**
 * Native select: accessible and keyboard friendly as is; the Base UI Select comes when a list needs search. It is as
 * wide as its longest option, and never wider than what holds it: a long name must not make the page scroll sideways.
 */
export function NativeSelect({ className, ...props }: ComponentProps<"select">) {
  return (
    <select
      className={cn(
        "h-(--control-h) max-w-full rounded-md border border-input bg-background px-2 text-sm disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}
